module.exports = __webpack_public_path__ + "img/overlay-sign-success.3cc323bf.png";